import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import * as React from 'react';

export const WorkflowSeparator = () => (
    <Flex height={32} justify="center" width={1}>
        <Box css={{ borderRight: '1px solid $gray200' }} height={1} />
    </Flex>
);
